import * as React from 'react'
import styled from 'styled-components'

import * as glyphs from '../../../icons/glyphs'
import * as S from '../../../styles'
import type { Color } from '../../../styles/form/switch'

export type SwitchProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  color?: Color
  label?: React.ReactNode
}

function SwitchComponent({
  className,
  color = 'blue',
  id,
  label,
  ...inputProps
}: SwitchProps): React.ReactElement<SwitchProps> {
  const stableId = React.useId()

  return (
    <S.switchElement.Content className={className} color={color} disabled={inputProps.disabled}>
      <S.input.HiddenFocusableInput type="checkbox" id={id ?? stableId} {...inputProps} />
      <S.switchElement.Switch htmlFor={id ?? stableId} disabled={inputProps.disabled}>
        <glyphs.stroke.Check size={12} />
      </S.switchElement.Switch>
      {label && <S.switchElement.Label>{label}</S.switchElement.Label>}
    </S.switchElement.Content>
  )
}
export const Switch = styled(SwitchComponent)``
